
<p-fieldset>
    <p-header class="article-title">
        <span class="article-title">{{'CUSTOMERS-LIST' | translate}}</span>
        <div class="header-buttons">
           <button class="fab-button outline" appFiltersButton pTooltip="Exibir/Ocultar Filtros" tooltipPosition="left">
                <i class="pi pi-filter"></i>
            </button>
        </div>
    </p-header>
    <form class="filters" (submit)="find()" appFilters>
        <div class="filter-row">
            <div class="form-control" *ngIf="marinaCompanies?.length">
                <label for="marinaCompanyId">{{'COMPANY' | translate}}</label>
                <p-dropdown [options]="marinaCompanies" name="marinaCompanyId" [placeholder]="'COMPANY' | translate"
                    appendTo="body" [title]="'COMPANY' | translate" (onChange)="changeCompany($event)">
                </p-dropdown>
            </div>
            <div class="form-control" *ngIf="loggedMarina.id === 191">
                  <label for="titleNumber">{{ 'TITLE_NUMBER' | translate }}</label>
                  <input pInputText type="number" [(ngModel)]="customerFilter.titleNumber" name="titleNumber">
                </div>
            <div class="form-control">
                <label for="name">{{'NAME' | translate}}</label>
                <input pInputText type="text" [(ngModel)]="customerFilter.name" name="name">
            </div>
            <div class="form-control">
                <label for="email">{{'EMAIL' | translate}}</label>
                <input pInputText type="text" [(ngModel)]="customerFilter.email" name="email">
            </div>
            <div class="form-control">
                <label for="phone">{{'PHONE' | translate}}</label>
                <input pInputText type="text" [(ngModel)]="customerFilter.phone" name="phone">
            </div>
            <div class="form-control">
                <label for="federalId">{{'FEDERAL_ID' | translate}} / {{'FEDERAL-ID.JURIDICAL' | translate}}</label>
                <input pInputText type="text" style="text-transform: uppercase" (change)="formatMaskFederalId(customerFilter.federalId)" mask="AAA.AAA.AAA-AA||AA.AAA.AAA/AAAA-00" [(ngModel)]="customerFilter.federalId" name="federalId">
            </div>
            <div class="form-control">
                <label for="groupIds">{{'GROUPS' | translate}}</label>
                <p-multiSelect [options]="groupsFilter" [(ngModel)]="customerFilter.groupIds" name="groupIds"
                    appendTo="body" selectedItemsLabel="{0} itens selecionados">
                </p-multiSelect>
            </div>
            <div class="form-control">
                <label for="licenceStates">{{'LICENSED' | translate}}</label>
                <p-multiSelect [options]="licenceStateFilter" [(ngModel)]="customerFilter.licenceStates" name="licenceStates"
                    appendTo="body" selectedItemsLabel="{0} itens selecionados">
                </p-multiSelect>
            </div>
            <div class="form-control">
                <label for="city">{{'CITY' | translate}}</label>
                <input pInputText type="text" [(ngModel)]="customerFilter.city" name="city">
            </div>
            <div class="form-control">
                <label for="state">{{'STATE' | translate}}</label>
                <input pInputText type="text" [(ngModel)]="customerFilter.state" name="state">
            </div>
            <div class="form-control">
                <label for="reviewed">{{'REVIEWED' | translate}}</label>
                <p-dropdown [(ngModel)]="customerFilter.reviewed" name="reviewed" appendTo="body"
                    [options]="[{label: 'Ambos', value: ''}, {label: 'Sim', value: true}, {label: 'Não', value: false}]">
                </p-dropdown>
            </div>
            <div class="form-control">
                <label for="active">{{'STATUS' | translate}}</label>
                <p-dropdown [(ngModel)]="customerFilter.active" name="active" appendTo="body"
                    [options]="[{label: 'Ambos', value: ''}, {label: 'Ativo', value: true}, {label: 'Inativo', value: false}]">
                </p-dropdown>
            </div>
            <div *ngIf="this.isWorkshop" class="form-control">
              <label for="customerProfile">{{'CUSTOMER_PROFILE' | translate}}</label>
              <p-dropdown [(ngModel)]="customerFilter.customerProfile" name="customerProfile" appendTo="body" [options]="customerProfiles"></p-dropdown>
            </div>
            <div class="form-control">
                <label for="customerType">{{'CUSTUMER-TYPES' | translate}}</label>
                <p-dropdown [(ngModel)]="customerType" name="customerType" appendTo="body"
                    [options]="[{label: 'Todos', value: ''},
                    {label: 'Autorizado', value: 'associated'},
                    {label: 'Proprietário', value: 'owner'},
                    {label: 'Prop./Aut.', value: 'ownAsso'},
                    {label: 'Sem Embarcação Associada', value: 'noBoat'}]">
                </p-dropdown>
            </div>
            <div class="form-control">
                <label for="userApp">{{'USER-APP' | translate}}</label>
                <p-dropdown [(ngModel)]="customerFilter.userApp" name="userApp" appendTo="body"
                    [options]="[{label: 'Ambos', value: ''}, {label: 'Sim', value: true}, {label: 'Não', value: false}]">
                </p-dropdown>
            </div>
            <div class="buttons">
              <p-button label="{{ 'CLEAR' | translate }}" styleClass="p-button-outlined p-button-secondary m-3" (click)="clear()"></p-button>
              <p-button label="Pesquisar" type="submit"></p-button>
            </div>
        </div>
    </form>
</p-fieldset>
    <div class="table m-2">
        <!-- Mensagem inicial quando nenhuma pesquisa foi realizada -->


        <!-- Tabela exibida apenas quando há resultados -->
        <p-table #tt  [value]="customersTable" [paginator]="true" [rows]="customerFilter.size" [lazy]="true" csvSeparator=";"
            [columns]="cols" [selection]="selectedCustomers" [totalRecords]="totalRecords" styleClass="easy-table"
            (onLazyLoad)="onChangePage($event)" [alwaysShowPaginator]="false" autoLayout="true">
            <ng-template pTemplate="caption">
              <div class="p-caption">
                <p-splitButton
                label="Cliente"
                icon="pi pi-plus"
                [model]="items"
                (onClick)="openNewCustomerSimplifiedFormDialog()"
              >
              </p-splitButton>
                <div class="flex flex-row align-items-start">
                    <div class="total-registers-container">
                        <span class="total-registers">{{ 'TOTAL-REGISTERS' | translate }}:
                            {{customersTable.length}} {{'OF' | translate}} {{tt.totalRecords}}
                          </span>
                      <span *ngIf="marinaImplantation !== undefined && marinaImplantation !== null && marinaImplantation.totalCustomerActive">
                            Clientes de Implantação: {{marinaImplantation.totalCustomers}}
                          </span>

                    </div>


                      <p-button
                      *ngIf="hasSearched && !noResults"
                    label="Download"
                    icon="pi  pi-download"
                    styleClass="p-button-outlined p-button-secondary mr-2 mb-2"
                    (onClick)="exportTable()">
                  </p-button>
                </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th class="text-center" [pSortableColumn]="'titleNumber'" *ngIf="loggedMarina.id === 191">
                        {{ 'TITLE' | translate}}
                    </th>
                    <th [pSortableColumn]="'userApp'">
                        {{ 'App' | translate}}
                    </th>
                    <!-- <th class="text-center">
                        {{ 'PHOTO' | translate}}
                    </th> -->
                    <th [pSortableColumn]="'name'">
                        {{ 'NAME' | translate }}
                        <p-sortIcon [field]="'name'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'marinaCompanyId'" *ngIf="marinaCompanies?.length > 0">
                        {{ 'Emp.' | translate }}
                        <p-sortIcon [field]="'marinaCompanyId'"></p-sortIcon>
                    </th>
                    <th class="text-center" [pSortableColumn]="'federalId'">
                        {{ 'FEDERAL-ID.GENERAL' | translate }}
                        <p-sortIcon [field]="'federalId'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'email'">
                        {{ 'PERSONAL-EMAIL' | translate }}
                        <p-sortIcon [field]="'email'"></p-sortIcon>
                    </th>
                    <th class="text-center" [pSortableColumn]="'phone'">
                        {{ 'CELLPHONE' | translate }}
                        <p-sortIcon [field]="'phone'"></p-sortIcon>
                    </th>
                    <th class="text-center" [pSortableColumn]="'group.name'">
                        {{ 'GROUP' | translate }}
                        <p-sortIcon [field]="'group.name'"></p-sortIcon>
                    </th>
                    <th class="text-center">{{ 'LOCATION' | translate }}</th>
                    <th [pSortableColumn]="'customerProfile'">
                      {{'CUSTOMER_PROFILE' | translate}}
                      <p-sortIcon [field]="'customerProfile'"></p-sortIcon>
                    </th>
                    <th class="text-center">{{ 'TYPE' | translate }}</th>
                    <th class="text-center" [pSortableColumn]="'reviewed'">
                        {{ 'REVIEWED' | translate }}
                        <p-sortIcon [field]="'reviewed'"></p-sortIcon>
                    </th>
                    <th class="text-center" [pSortableColumn]="'active'">
                        {{ 'STATUS' | translate }}
                        <p-sortIcon [field]="'active'"></p-sortIcon>
                    </th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-customer let-index>
                <tr [ngClass]="{'em-alert': islicenseExpired(customer)}">
                    <td class="text-center" *ngIf="loggedMarina.id === 191">
                        <span style="display: flex; align-items: center; justify-content: center;">
                            <i class="pi pi-bookmark" *ngIf="customer.titleNumber"
                               style="font-size: 20px; color: #313131; cursor: pointer;"
                               [pTooltip]="'Título: ' + customer.titleNumber"
                               tooltipPosition="top"></i>
                        </span>
                    </td>
                    <td pTooltip="Usuário do App Cliente">
                        <span style="display: flex; align-items: center; justify-content: center;">
                            <img src="assets/images/mobile.png" alt="" *ngIf="customer.userApp"
                                style="height: 30px; width: auto;">
                        </span>
                    </td>
                    <!-- <td pTooltip="Foto do Cliente" class="text-center">
                        <span style="display: flex; align-items: center; justify-content: center;">
                             <i class="pi pi-image" *ngIf="customer.photoUrl" style="font-size: 20px; color: #313131; cursor: pointer;" (click)="openPhotoDialog(customer)"></i>
                        </span>
                    </td> -->
                    <td>{{customer.name}}</td>
                    <td class="text-center" *ngIf="marinaCompanies?.length > 0" [pTooltip]="customer.companyName">
                        {{customer.marinaCompanyId ? getCompanyIndex(customer.marinaCompanyId) : 1}}</td>
                    <td class="text-center">{{customer.federalId}}</td>
                    <td>{{customer.email}}</td>
                    <td class="text-center">{{customer.phone}}</td>
                    <td class="text-center">
                        <p-dropdown [options]="groups" appendTo="body" styleClass="max-width"
                            [(ngModel)]="customer.groupId" [name]="customer.groupId" (onChange)="changeGroup(customer)" *ngIf="showInvoiceGroup(customer)">
                        </p-dropdown>
                    </td>
                    <td class="text-center">
                        <span>
                            {{customer.location}}
                        </span>
                    </td>
                    <td>{{customer.customerProfile | translate}}</td>
                    <td class="text-center">
                        <span>
                            {{customer.customerType}}
                        </span>
                    </td>
                    <td class="text-center">
                        <span *ngIf="customer.reviewed" class="pi pi-check-circle" style="color: rgb(34, 162, 34); font-size: 1.5rem;"
                              [pTooltip]="'Revisado'" tooltipPosition="bottom" (click)="updateReviewed(customer)"></span>
                        <span *ngIf="!customer.reviewed" class="pi pi-times-circle" style="color: rgb(176, 66, 66); font-size: 1.5rem;"
                              [pTooltip]="'Não Revisado'" tooltipPosition="bottom" (click)="updateReviewed(customer)"></span>
                    </td>
                    <td class="text-center">
                        <div style="position: relative; display: inline-block;">
                            <p-inputSwitch [(ngModel)]="customer.active"></p-inputSwitch>
                            <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; cursor: pointer; z-index: 1;"
                                 [pTooltip]="customer.active ? 'Status Ativo' : 'Status Inativo'" tooltipPosition="bottom"
                                 (click)="confirmStatusChange($event, customer)"></div>
                        </div>
                    </td>
                  <td>
                    <p-menu appendTo="body" #menu [model]="menuItems" [popup]="true" [showTransitionOptions]="'150ms'"
                            [hideTransitionOptions]="'150ms'"></p-menu>
                    <button (click)="menu.toggle($event); changeSelectedItem(customer)" pButton type="button"
                            icon="pi pi-ellipsis-v" class="p-button-text p-button-rounded p-button-lg"></button>

                  </td>
                </tr>
            </ng-template>
        </p-table>

        <div *ngIf="!hasSearched" class="empty-state-message">
            <div class="message-container">
                <i class="pi pi-search" style="font-size: 3rem"></i>
                <h3>Adicione algum filtro, ou apenas clique em Pesquisar para exibir os dados</h3>
            </div>
        </div>

        <!-- Mensagem quando a pesquisa não retornou resultados -->
        <div *ngIf="hasSearched && noResults" class="empty-state-message">
            <div class="message-container">
                <i class="pi pi-info-circle" style="font-size: 3rem"></i>
                <h3>Nenhum resultado foi encontrado</h3>
            </div>
        </div>
    </div>
